import { createContext, useContext } from 'react';

const HospitalContext = createContext(null);

export const HospitalProvider = HospitalContext.Provider;

export function useHospital() {
  return useContext(HospitalContext);
}
